import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Section from '../../../componentsv2/Section';
import Typography from '../../../componentsv2/Typography';
import { COLORS } from '../../../themev2';
import { NonActiveCreditLineIllustration, HoverArrowIcon } from './icons';
import { useLazyTranslation } from '../../../hooks/i18n';
import { REVOLVING_CREDIT_LINE } from '../../../constants/auth';

export default function NonActiveCreditLineCard() {
  const { t } = useLazyTranslation(['common', 'revolving-credit-line']);
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => navigate(REVOLVING_CREDIT_LINE)}
      sx={{
        display: 'flex',
        flex: 1,
        cursor: 'pointer',
        '& .illustration-default': { display: 'block' },
        '& .illustration-hover': { display: 'none' },
        '&:hover .illustration-default': { display: 'none' },
        '&:hover .illustration-hover': { display: 'block' },
      }}
    >
      <Section
        sx={{
          background: '#EEF1FB',
          position: 'relative',
          overflow: 'hidden',
          padding: '2em',
          flex: 1,
          boxSizing: 'border-box',
        }}
      >
        <Grid container>
          <Grid item xs={9} sx={{ zIndex: 2 }}>
            <Typography
              sx={{ fontSize: '16px', fontWeight: 700, color: COLORS.brand.night, lineHeight: '28px' }}
            >
              {t('common:revolvingCredit')}
            </Typography>
            <Typography
              sx={{ fontSize: '14px', fontWeight: 400, color: COLORS.gray[1100], lineHeight: '24px', mt: 1 }}
            >
              {t('revolving-credit-line:requestPage.subtitle')}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              display: { xs: 'none', md: 'initial' },
              zIndex: 1,
            }}
          >
            <div className="illustration-default">
              <NonActiveCreditLineIllustration />
            </div>
          </Grid>
          <Grid
            item
            className="illustration-hover"
            sx={{
              position: 'absolute',
              top: '50%',
              right: '2em',
              transform: 'translateY(-50%)',
              display: { xs: 'none', md: 'flex' },
              zIndex: 1,
            }}
          >
            <HoverArrowIcon />
          </Grid>
        </Grid>
      </Section>
    </Box>
  );
}
